(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6706],{

/***/ 38732:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Home; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(50029);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(87794);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ./src/action/index.ts + 2 modules
var action = __webpack_require__(37121);
// EXTERNAL MODULE: ./node_modules/axios/index.js
var axios = __webpack_require__(9669);
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);
;// CONCATENATED MODULE: ./src/utils/download.ts




var downloadFile = /*#__PURE__*/function () {
  var _ref = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(id, resourceId, fileName) {
    var preview,
        pathname,
        isSupportCenter,
        res,
        data,
        blob,
        link,
        _args = arguments;
    return regenerator_default().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            preview = _args.length > 3 && _args[3] !== undefined ? _args[3] : false;
            pathname = window.location.pathname; // 支持中心及新闻

            isSupportCenter = ['tutorial', 'faq', 'news'].some(function (str) {
              return pathname.indexOf(str) > -1;
            });

            if (!isSupportCenter) {
              _context.next = 9;
              break;
            }

            _context.next = 6;
            return action/* action.getResourceForSupportCenter */.a.getResourceForSupportCenter(resourceId);

          case 6:
            res = _context.sent;
            _context.next = 12;
            break;

          case 9:
            _context.next = 11;
            return action/* action.getResource */.a.getResource(id, resourceId);

          case 11:
            res = _context.sent;

          case 12:
            if (!res) {
              _context.next = 24;
              break;
            }

            if (!preview) {
              _context.next = 15;
              break;
            }

            return _context.abrupt("return", res);

          case 15:
            _context.next = 17;
            return axios_default().get(res, {
              responseType: 'arraybuffer'
            });

          case 17:
            data = _context.sent;
            blob = new Blob([data.data]);
            link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);
            link.download = fileName;
            link.click();
            window.URL.revokeObjectURL(link.href);

          case 24:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function downloadFile(_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}();
// EXTERNAL MODULE: ./node_modules/@xylink/xy-editor/dist/preview.js
var preview = __webpack_require__(80175);
var preview_default = /*#__PURE__*/__webpack_require__.n(preview);
// EXTERNAL MODULE: ./node_modules/@xylink/xy-editor/dist/css/preview.css
var css_preview = __webpack_require__(23831);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./src/components/preview/index.module.scss
var index_module = __webpack_require__(77448);
var index_module_default = /*#__PURE__*/__webpack_require__.n(index_module);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/preview/index.tsx



 // import Preview from './preview.js';

 // import './css/preview.css';




function Home(props) {
  var classNames = props.classNames,
      detail = props.detail,
      _props$pdfPreview = props.pdfPreview,
      pdfPreview = _props$pdfPreview === void 0 ? false : _props$pdfPreview,
      _props$isImgView = props.isImgView,
      isImgView = _props$isImgView === void 0 ? true : _props$isImgView;
  var id = detail.id,
      intro = detail.intro,
      viewCount = detail.viewCount,
      content = detail.content,
      releaseTime = detail.releaseTime,
      enclosureList = detail.enclosureList,
      author = detail.author;

  var onDownload = /*#__PURE__*/function () {
    var _ref = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(item) {
      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              downloadFile(id, item.resourceId, item.resourceName);

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function onDownload(_x) {
      return _ref.apply(this, arguments);
    };
  }();

  var onPreviewPdf = /*#__PURE__*/function () {
    var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee2(item) {
      var url;
      return regenerator_default().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return downloadFile(id, item.resourceId, item.resourceName, true);

            case 2:
              url = _context2.sent;
              console.log(url);

              if (typeof url === 'string') {
                window.open(url, '_blanl');
              }

            case 5:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function onPreviewPdf(_x2) {
      return _ref2.apply(this, arguments);
    };
  }();

  return /*#__PURE__*/(0,jsx_runtime.jsx)((preview_default()), {
    isWebsite: true,
    className: classnames_default()((index_module_default()).container, !!classNames && classNames),
    viewCount: viewCount,
    author: author,
    enclosure: enclosureList ? {
      enclosureList: enclosureList,
      onDownloadEnclosure: onDownload,
      onPreviewPdf: pdfPreview ? onPreviewPdf : undefined
    } : undefined,
    releaseTime: releaseTime,
    intro: intro,
    content: content,
    isImgView: isImgView
  });
}

/***/ }),

/***/ 36107:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ Home; }
/* harmony export */ });
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var components_layout__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(16569);
/* harmony import */ var components_preview__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(38732);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85893);


 // import useSWR, { SWRConfig } from 'swr';



function Home() {
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)(components_layout__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)((next_head__WEBPACK_IMPORTED_MODULE_0___default()), {
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("title", {
        children: "\u5173\u4E8E\u52A0\u5F3A\u5B89\u5168\u4E13\u9879\u6CBB\u7406\u7684\u8BF4\u660E"
      })
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("section", {
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(components_preview__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        detail: {
          id: '1',
          intro: '关于加强安全专项治理的说明',
          content: '<p>&nbsp; &nbsp; &nbsp; &nbsp; 4月18日，我司发现小鱼专有云视频平台被非法攻击，立即紧急组织技术团队，协同安全专家进行排查，目前已及时处理并修复。 就此事件，我司已与公安机关联系并沟通。</p>\n<p>&nbsp; &nbsp; &nbsp; &nbsp; 产品安全是云视频的头等大事，我司已成立安全专项小组，并聘请安全专家团队，全力以赴为用户提供最可靠的安全保障。</p>\n<p><br /><br /></p>\n<p class="sign no-mb" style="text-align: right;">2021年4月20日</p>'
        }
      })
    })]
  });
}

/***/ }),

/***/ 1742:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/statement2",
      function () {
        return __webpack_require__(36107);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 77448:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"preview_container__Yt65c","border__px":"preview_border__px__y0WDs","border__px-before":"preview_border__px-before__hSj6I","border__px-before1":"preview_border__px-before1__4Y1Em","border-children1":"preview_border-children1__BW1YI","border-children2":"preview_border-children2__8gbEe","for-mobile":"preview_for-mobile__rsD_r","for-pc":"preview_for-pc__ER2pR"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [5259,1747,4662,7115,7602,2178,4569,9774,2888,179], function() { return __webpack_exec__(1742); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);